import { FormattedDate, FormattedMessage } from 'react-intl';
import { Dayjs } from 'dayjs';
import Typography from '@mui/material/Typography';
import { Flex } from '@atoms/layout';
import { Skeleton } from '../../molecules/feedback';

type GreetingProps = {
  loading: boolean;
  name: string;
  date: Dayjs;
};
export function Greeting({ date, name, loading }: GreetingProps) {
  return (
    <Flex column gap={1}>
      <Typography variant="body1">
        <FormattedDate value={date.toDate()} weekday="long" month="long" day="numeric" />
      </Typography>
      <Skeleton variant="rounded" show={loading} width={200}>
        <Typography variant="h4" noWrap title={name}>
          <FormattedMessage id="common.greeting" values={{ name }} />
        </Typography>
      </Skeleton>
    </Flex>
  );
}
